module.exports = __webpack_public_path__ + "static/media/IMG_6596.2b75ff8b.jpg";